<template>
  <tr 
    class="review-list-row"
  >
    <td class="drag-handle">
      <img
        :src="require('@/assets/images/drag-handle.svg')"
        alt="並び替え"
        class="drag-icon"
        @error="handleDragIconError"
      />
    </td>
    <td class="order-number">
      {{ displayNumber }}
    </td>
    <td>
      <p
        @click="showPreviewList(reviewLists._id)"
        style="color: #036AC9; cursor: pointer;"
      >
        {{ reviewLists.title }}
      </p>
    </td>
    <td>
      <p
        v-for="client_users in reviewLists.client_users"
        :key="client_users._id"
      >
        {{ client_users.full_name }}
      </p>
    </td>
    <td style="text-align: center !important;">
      <button
        class="btn-plain btn-heart template-Btn"
        @click="editReviewList()"
      >
        <img
          :src="require('@/assets/images/pencil.svg')"
          alt="編集"
          class="icon-label"
        />
      </button>
      <button
        class="btn-plain btn-heart template-Btn ms-2"
        v-b-modal="reviewLists._id"
        @click="openDeletePopup()"
      >
        <img
          :src="require('@/assets/images/dustbin.svg')"
          alt="削除"
          class="icon-label"
        />
      </button>
    </td>
    <CreateReviewList
      v-if="showCreateReviewListPopup"
      :isEditing="true"
      :reviewLists="reviewLists"
      @hideModal="hideModal"
    />
    <ConfirmationModal
      ref="confirmationModal"
      :message="'このリストを削除しますか？'"
      @cancel="closeDeleteModal"
      @confirm="destroy"
    />
  </tr>
</template>

<script>
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import { mapMutations, mapActions } from 'vuex';
import CreateReviewList from './CreateReviewList.vue';
import ConfirmationModal from '../../utils/ConfirmationModal.vue';

export default {
  name: 'ReviewListRowDraggable',
  props: {
    userData: Object,
    reviewLists: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    displayNumber: {
      type: Number,
      required: true,
    },
  },
  components: {
    CreateReviewList,
    ConfirmationModal,
  },
  data() {
    return {
      showCreateReviewListPopup: false,
      showDeleteConfirmationPopup: false,
      showReviewListPopup: false,
      errors: [],
    };
  },
  methods: {
    ...mapMutations({
      unsetUser: 'unsetUser',
      unsetReviewList: 'unsetReviewList',
      setPreviewApplicants: 'setPreviewApplicants',
    }),
    ...mapActions({
      loadPreviewList: 'loadPreviewApplicants',
    }),
    showPreviewList(reviewId) {
      window.open(`/preview-applicants/${reviewId}`, '_blank');
    },
    hidePreviewListModal() {
      this.showReviewListPopup = false;
    },
    openDeletePopup() {
      this.$refs.confirmationModal.show();
    },
    closeDeleteModal() {
      this.$refs.confirmationModal.hide();
    },
    editReviewList() {
      this.showCreateReviewListPopup = true;
    },
    hideModal() {
      this.showCreateReviewListPopup = false;
    },
    destroy(reviewList) {
      this.loading = true;
      ApiService.delete(Api.endpoints.DELETE_REVIEW_LIST(this.reviewLists._id))
        .then(() => {
          this.unsetReviewList(this.reviewLists);
          this.loading = false;
        })
        .catch((error) => {
          this.parseErrorResponse(error.response);
          if (this.errors && this.errors.length) {
            this.$emit('error', this.errors[0]);
          }
        });
    },
    handleDragIconError(e) {
      // Fallback: show text if icon doesn't exist
      e.target.style.display = 'none';
      e.target.parentElement.innerHTML = '⋮⋮';
    },
  },
};
</script>

<style scoped>
td {
  height: 50px;
  font-weight: normal;
  text-align: left;
  border-bottom: 1px solid #787878 !important;
  vertical-align: middle;
  padding: 0.75rem;
}

.order-number {
  text-align: center;
  font-weight: 600;
  color: #333;
  font-size: 14px;
  vertical-align: middle;
}

.drag-handle {
  text-align: center;
  cursor: grab;
  padding: 0.5rem;
  user-select: none;
  vertical-align: middle;
}

.drag-handle:active {
  cursor: grabbing;
}

.drag-icon {
  width: 36px;
  height: 44px;
  opacity: 0.7;
  transition: opacity 0.2s;
  display: block;
  margin: 0 auto;
}

.drag-handle:hover .drag-icon {
  opacity: 1;
}

.review-list-row {
  transition: background-color 0.2s;
}

.review-list-row:hover {
  background-color: #f8f9fa;
}

.review-list-row.dragging {
  opacity: 0.5;
}

.review-list-row td {
  vertical-align: middle;
}

.dlt-block {
  text-align: center;
}

.dlt-block i {
  font-size: 30px;
  color: red;
  margin-bottom: 10px;
}
</style>
